/**
 * Moderation Cases Completed Panel
 *
 * Displays the number of completed moderation cases
 */

import { Card, Shimmer, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationStatsPanel.css';

interface ModerationCasesCompletedPanelProps {
  casesCompleted: number;
  isLoading?: boolean;
}

export function ModerationCasesCompletedPanel({ casesCompleted, isLoading = false }: ModerationCasesCompletedPanelProps) {
  if (isLoading) {
    return (
      <Card elevation="low" padding="medium">
        <div className={styles.panelContent}>
          <div className={styles.header}>
            <span className={styles.title}>CASES COMPLETED</span>
          </div>
          <Shimmer className={styles.shimmerValue} label="Loading cases completed count" />
        </div>
      </Card>
    );
  }

  return (
    <Card elevation="low" padding="medium">
      <div className={styles.panelContent}>
        <div className={styles.header}>
          <span className={styles.title}>CASES COMPLETED</span>
        </div>
        <Text as="div" className={styles.value}>
          {casesCompleted.toLocaleString()}
        </Text>
        <Text as="div" className={styles.subtitle}>
          All time
        </Text>
      </div>
    </Card>
  );
}
